// @flow
import React from 'react'
import i18n from 'i18next'
import { Grid } from '@material-ui/core'

import styles from './styles'

type Props = {
  color?: string,
  acceptCookies: Function,
  isAtHomePage?: boolean
}

export const CookiesMessage = (props: Props) => (
  <div style={styles.container(props.isAtHomePage)}>
    <div style={styles.child}>
      <Grid container alignItems='center' justify='center'>
        <Grid item xs={12} md={10}>
          <p style={styles.message(props.color)}>
            <strong>
              {i18n.t('cookiesMessage.title')}
            </strong>
            {i18n.t('cookiesMessage.message')}
            <a style={styles.anchor(props.color)} href={i18n.t('appshell.links.cookiesPolicy')}>
              {i18n.t('cookiesMessage.link')}
            </a>
          </p>
        </Grid>
        <Grid item xs={12} md={2}>
          <Grid container alignItems='center' justify='center'>
            <button onClick={() => props.acceptCookies()} style={styles.button(props.color)}>
              {i18n.t('cookiesMessage.accept')}
            </button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  </div >
)

export default CookiesMessage
